import Icon from '@/components/ui/AppIcon';

interface MarketFactor {
  id: string;
  title: string;
  description: string;
  impact: 'positive' | 'negative' | 'neutral';
  icon: string;
}

interface MarketFactorsPanelProps {
  factors: MarketFactor[];
}

const MarketFactorsPanel = ({ factors }: MarketFactorsPanelProps) => {
  const getImpactColor = (impact: string) => {
    switch (impact) {
      case 'positive':
        return 'bg-success/10 text-success border-success/20';
      case 'negative':
        return 'bg-error/10 text-error border-error/20';
      default:
        return 'bg-muted text-muted-foreground border-border';
    }
  };

  const getImpactIcon = (impact: string) => {
    switch (impact) {
      case 'positive':
        return 'ArrowTrendingUpIcon';
      case 'negative':
        return 'ArrowTrendingDownIcon';
      default:
        return 'MinusIcon';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-elevation-sm p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-md">
          <Icon name="LightBulbIcon" size={20} className="text-primary" />
        </div>
        <div>
          <h2 className="font-heading font-bold text-xl text-foreground">Market Factors</h2>
          <p className="text-sm text-muted-foreground">Current influences on fish prices</p>
        </div>
      </div>

      <div className="space-y-4">
        {factors.map((factor) => (
          <div
            key={factor.id}
            className={`border rounded-md p-4 transition-smooth hover:shadow-elevation-sm ${getImpactColor(factor.impact)}`}
          >
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 mt-1">
                <Icon name={factor.icon as any} size={24} />
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <h3 className="font-heading font-semibold text-base">{factor.title}</h3>
                  <Icon name={getImpactIcon(factor.impact) as any} size={16} />
                </div>
                <p className="text-sm opacity-90">{factor.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-muted rounded-md">
        <div className="flex items-start gap-3">
          <Icon name="InformationCircleIcon" size={20} className="text-primary flex-shrink-0 mt-0.5" />
          <p className="text-sm text-foreground">
            Price variations are influenced by multiple factors including weather conditions, supply chain logistics, seasonal availability, and market demand. FishBite ensures transparent pricing with real-time updates.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MarketFactorsPanel;